import React from 'react';
import { useLicensingExperienceOptional } from '../../contexts/LicensingExperienceContext';
import { getPlatformBranding } from '../../utils/licensingPlatformBranding';

/** Shown on viewports where the split-panel left promo is hidden (see Auth/style.css). */
export default function AuthMobileHero({ title, description }) {
  const { mode } = useLicensingExperienceOptional();
  const branding = getPlatformBranding(mode);

  return (
    <div className="mobile-content">
      <div className="mobile-hero">
        <h1 className="mobile-title">{title ?? branding.title}</h1>
        <p className="mobile-description">
          {description ?? branding.description}
        </p>
      </div>
    </div>
  );
}
